import { TICK_DT, MAX_TICKS_PER_FRAME } from '../constants.js';

export class GameLoop {
  constructor(tickCallback, renderCallback) {
    this.tickDt = TICK_DT;
    this.accumulator = 0;
    this.lastTime = 0;
    this.tickCallback = tickCallback;
    this.renderCallback = renderCallback;
    this._running = false;
    this._boundLoop = this._loop.bind(this);
  }

  start() {
    this._running = true;
    this.lastTime = performance.now() / 1000;
    requestAnimationFrame(this._boundLoop);
  }

  stop() {
    this._running = false;
  }

  _loop(timestampMs) {
    if (!this._running) return;
    requestAnimationFrame(this._boundLoop);

    const now = timestampMs / 1000;
    let frameTime = now - this.lastTime;
    this.lastTime = now;

    // Clamp to prevent spiral of death
    if (frameTime > 0.25) frameTime = 0.25;

    this.accumulator += frameTime;

    let tickCount = 0;
    while (this.accumulator >= this.tickDt && tickCount < MAX_TICKS_PER_FRAME) {
      this.tickCallback(this.tickDt);
      this.accumulator -= this.tickDt;
      tickCount++;
    }

    const alpha = this.accumulator / this.tickDt;
    this.renderCallback(alpha);
  }
}
